import { render, staticRenderFns } from "./TemplateGalleryBardCard.vue?vue&type=template&id=036b3d59&scoped=true"
import script from "./TemplateGalleryBardCard.vue?vue&type=script&lang=js"
export * from "./TemplateGalleryBardCard.vue?vue&type=script&lang=js"
import style0 from "./TemplateGalleryBardCard.vue?vue&type=style&index=0&id=036b3d59&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "036b3d59",
  null
  
)

export default component.exports